export default __webpack_public_path__ + "img/cxfMYsHr.307f11f9.svg";